<template>
  <div class="drawer">
    <div class="user-avatar">
      <div v-if="curUser" class="avatar-details">
        <h5>{{ curUser.Username }}</h5>
        <p>{{ curUser.Type }}</p>
      </div>
    </div>
    <div class="accordion menu" id="accordionPanelsStayOpenExample">
      <!-- System Update Notification -->
      <div class="accordion-item" v-if="isUpdateAvailable">
        <a @click="updateApp">
          <font-awesome-icon class="icon text-info" icon="Ffa-solid fa-exclamation-circle"/>
          <div class="d-flex flex-column text-center">
            Update Is Available
            <span class="text-sm" @click="updateApp">Click to Update</span>
          </div>
        </a>
      </div>

      <!-- Dashboard Section -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseDashboard" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseDashboard">
            <font-awesome-icon class="icon" icon="fa-solid fa-home"/>
            Dashboard
          </button>
        </h2>
        <div id="panelsStayOpen-collapseDashboard" class="accordion-collapse collapse">
          <div class="accordion-body">
            <router-link @click.native="back" class="route-btn w-100 bg-transparent" :to="{ name : 'user-dashboard' }">
              <font-awesome-icon class="icon" icon="fa-solid fa-chart-simple"/>
              My Dashboard
            </router-link>

            <a @click="UserPerformance" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="chart-line"/>
              Performance Statistics
            </a>

            <a @click="AppMarket" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-store"/>
              App Market
            </a>

            <a @click="trainingSection" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-briefcase"/>
              Training Section
            </a>
          </div>
        </div>
      </div>

      <!-- Support & Tickets Section -->
      <div class="accordion-item" v-if="permissions && permissions.support">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseSupport" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseSupport">
            <font-awesome-icon class="icon" icon="fa-solid fa-headset"/>
            Support & Tickets
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSupport" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="createTicket" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-plus"/>
              Create Ticket
            </a>

            <a @click="searchTicket" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="magnifying-glass"/>
              Ticket Search
            </a>

            <a @click="disputes" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="triangle-exclamation"/>
              Disputes
            </a>
          </div>
        </div>
      </div>

      <!-- Customer Management Section -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseCustomers" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseCustomers">
            <font-awesome-icon class="icon" icon="fa-solid fa-users"/>
            Customer Management
          </button>
        </h2>
        <div id="panelsStayOpen-collapseCustomers" class="accordion-collapse collapse">
          <div class="accordion-body">
            <router-link @click.native="viewCustomers" class="route-btn w-100 bg-transparent" :to="{ name : 'user-dashboard' }">
              <font-awesome-icon class="icon" icon="users"/>
              Customers List
            </router-link>

            <a @click="kycValidation" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="clock"/>
              KYC Validation
            </a>

            <a @click="navigateToFollowUp" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="pen-to-square"/>
              Customer Follow-up
            </a>

            <a @click="viewLibratas" class="route-btn w-100 bg-transparent" v-if="permissions && permissions.libratas">
              <font-awesome-icon class="icon" icon="fa-solid fa-chart-line"/>
              Libratas
            </a>
          </div>
        </div>
      </div>

      <!-- Subscription & Products Section -->
      <div class="accordion-item" v-if="permissions && permissions.subscription">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseSubscriptions" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseSubscriptions">
            <font-awesome-icon class="icon" icon="fa-solid fa-cubes"/>
            Subscriptions & Products
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSubscriptions" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="viewSubs" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-list"/>
              Subscription List
            </a>
            <a @click="viewPrimaryProducts" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-box"/>
              Primary Products
            </a>
            <a @click="viewProductBillingCycles" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-clock"/>
              Billing Cycles
            </a>
            <a @click="viewAddons" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-cubes"/>
              Addons
            </a>
            <a @click="viewSubscriptionInvoices" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-file-invoice-dollar"/>
              Subscription Invoices
            </a>
            <a @click="viewSubscriptionBillCalculator" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="calculator"/>
              Bill Calculator
            </a>
          </div>
        </div>
      </div>

      <!-- Project Management Section -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseProjects" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseProjects">
            <font-awesome-icon class="icon" icon="fa-solid fa-list-check"/>
            Project Management
          </button>
        </h2>
        <div id="panelsStayOpen-collapseProjects" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="openProjectManagement" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="list-check"/>
              Projects Overview
            </a>
            <a @click="viewJobCard" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="eye"/>
              Job Cards
            </a>
            <a @click="setup" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="list-check"/>
              Project Setup
            </a>
            <a @click="stockDispatch" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="boxes-stacked"/>
              Stock Management
            </a>
          </div>
        </div>
      </div>

      <!-- Sales & Marketing Section -->
      <div class="accordion-item" v-if="permissions && permissions.sales">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseSales" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseSales">
            <font-awesome-icon class="icon" icon="fa-solid fa-money-check-dollar"/>
            Sales & Marketing
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSales" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="openSalesPersonDashboard" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="user"/>
              My Sales Dashboard
            </a>
            <a @click="openAllSales" class="route-btn w-100 bg-transparent" v-if="permissions.financialReports">
              <font-awesome-icon class="icon" icon="fa-solid fa-money-check-dollar"/>
              Overall Sales
            </a>
            <a @click="viewAds" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="headset"/>
              Marketing Ads
            </a>
            <a @click="viewLeads" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="pencil"/>
              Sales Leads
            </a>
          </div>
        </div>
      </div>

      <!-- Finance Section -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseFinance" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseFinance">
            <font-awesome-icon class="icon" icon="fa-solid fa-file-invoice-dollar"/>
            Finance
          </button>
        </h2>
        <div id="panelsStayOpen-collapseFinance" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="requestFunds" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="hand-holding-dollar"/>
              Request Funds
            </a>
          </div>
        </div>
      </div>

      <!-- Smart Invoice Section -->
      <div class="accordion-item" v-if="permissions && permissions.smartInvoicing">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseSmartInvoice" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseSmartInvoice">
            <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
            Smart Invoice
          </button>
        </h2>
        <div id="panelsStayOpen-collapseSmartInvoice" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="viewSmartInvoiceSignup" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="address-card"/>
              Signups
            </a>
            <a @click="viewSmartInvoiceStats" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
              SmartInvoice Dashboard
            </a>
          </div>
        </div>
      </div>

      <!-- HR & Staff Section -->
      <div class="accordion-item" v-if="permissions && (permissions.staffManagement || permissions.manager)">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseHR" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseHR">
            <font-awesome-icon class="icon" icon="fa-solid fa-users"/>
            HR & Staff
          </button>
        </h2>
        <div id="panelsStayOpen-collapseHR" class="accordion-collapse collapse">
          <div class="accordion-body">
            <!-- Staff Management -->
            <div v-if="permissions && permissions.staffManagement">
              <a @click="viewStaff" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="address-card"/>
                Staff Directory
              </a>
              <a @click="viewRoles" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-pencil"/>
                Roles & Permissions
              </a>
              <a @click="manageDepartments" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-users"/>
                Departments
              </a>
              <a @click="disciplinary" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-eye"/>
                Disciplinary Actions
              </a>
            </div>

            <!-- Leave Management -->
            <div class="mt-2">
              <a @click="requestLeave" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-person-walking-luggage"/>
                Request Leave
              </a>
              <a v-if="permissions && permissions.manager" @click="viewRequestLeave" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-bus"/>
                Manage Leave Requests
              </a>
              <a v-if="permissions && permissions.staffManagement" @click="viewLeaveReports" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-bus"/>
                Leave Configuration
              </a>
            </div>

            <!-- Clearance -->
            <div class="mt-2">
              <a v-if="permissions && permissions.manager" @click="managerClearance" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-check-circle"/>
                Clearance Approval
              </a>
              <a v-if="permissions && permissions.staffManagement" @click="viewClearanceStatus" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-bus"/>
                Clearance Status
              </a>
              <a v-if="permissions && permissions.staffManagement" @click="deathClearance" class="route-btn w-100 bg-transparent">
                <font-awesome-icon class="icon" icon="fa-solid fa-book-skull"/>
                Death Clearance Config
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- Office & Branch Management -->
      <div class="accordion-item" v-if="permissions && permissions.branchAndLocation">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseBranch" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseBranch">
            <font-awesome-icon class="icon" icon="fa-solid fa-building"/>
            Office & Branch
          </button>
        </h2>
        <div id="panelsStayOpen-collapseBranch" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="openOfficeDashboard" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="address-card"/>
              Office Dashboard
            </a>
            <a @click="openOfficeManagement" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="building"/>
              Office Management
            </a>
          </div>
        </div>
      </div>

      <!-- Development Section -->
      <div class="accordion-item">
        <h2 class="accordion-header">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#panelsStayOpen-collapseDevelopment" aria-expanded="false"
                  aria-controls="panelsStayOpen-collapseDevelopment">
            <font-awesome-icon class="icon" icon="fa-solid fa-code"/>
            Development
          </button>
        </h2>
        <div id="panelsStayOpen-collapseDevelopment" class="accordion-collapse collapse">
          <div class="accordion-body">
            <a @click="Projects" class="route-btn w-100 bg-transparent">
              <font-awesome-icon class="icon" icon="fa-diagram-project"/>
              Development Projects
            </a>
          </div>
        </div>
      </div>

      <!-- Settings & Logout -->
      <div class="mt-3">
        <a @click="settingsPage" class="route-btn border w-100 bg-transparent btn-cont" v-if="permissions && permissions.settings">
          <svg
              class="settings-btn"
              xmlns="http://www.w3.org/2000/svg"
              height="30"
              viewBox="0 -960 960 960"
              width="30"
              fill="#606d77"
          >
            <path class="icons"
                  d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z"
            ></path>
          </svg>
          Settings
        </a>

        <a @click="logOut" class="route-btn border w-100 bg-transparent mt-2">
          <font-awesome-icon class="icon" icon="lock"/>
          Logout
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import {Storage} from "@/services/Storage"
import {mapActions, mapGetters} from "vuex";

export default {
  name: "NavigationDrawer",
  data() {
    return {
      userRole: '',
    }
  },
  props: {
    close: {
      type: Function,
      required: true,
    }
  },

  created() {
    this.assign();
    this.getAllRoles();
  },
  computed: {
    ...mapGetters(['getRoles']),
    permissions() {
      return this.$store.getters.getPermissions;
    },
    roles() {
      return this.$store.getters.getRoles;
    },
    curUser() {
      let user = this.$store.getters.getCurrentUser;
      if (user) {
        return user;
      }
      return {
        Username: 'Null',
        Type: 'Unknown',
      }
    },
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
    currentUserRole() {
      return this.getRoles.find(role => role.roleName === this.userRole);
    }
  },
  methods: {
    ...mapActions(['getAllRoles']),
    checker() {
      console.log(this.permissions);
    },
    registerDevice() {
      this.$store.dispatch('checkAndRegisterDevice');
    },
    assign() {
      this.userRole = this.curUser.Type;
      console.log('this is the role', this.userRole);
    },
    back() {
      if (this.close) {
        this.close();
      } else {
        console.log("Close not defined")
      }
    },
    async navigateToFollowUp() {
      this.back();
      return this.$router.push({ name: 'FollowUp' });
    },
    someMethod() {
      console.log(this.curUser, "this is our currently logged in user");
      // other logic...
    },
    createTicket(){
      this.back();
      return this.$router.push({ name : `create-ticket` });
    },
    viewSubs(){
      this.back();
      return this.$router.push({ name : `subs` });
    },
    viewPrimaryProducts(){
      this.back();
      return this.$router.push({ name : `PrimaryProducts` });
    },
    viewProductBillingCycles(){
      this.back();
      return this.$router.push({ name : `ProductBillingCycles` });
    },
    viewAddons(){
      this.back();
      return this.$router.push({ name : `Addons` });
    },
    viewSubscriptionInvoices(){
      this.back();
      return this.$router.push({ name : `SubscriptionInvoices` });
    },
    viewSubscriptionBillCalculator(){
      this.back();
      return this.$router.push({ name : `SubscriptionBillCalculator` });
    },

    onlineChecker() {
      this.back();
      return this.$router.push({ name: 'online-checker' });
    },

    searchTicket() {
      this.back();
      this.$router.push({ name: 'search-ticket' })
    },
    viewJobCard() {
      this.back();
      this.$router.push({ name: 'viewJobCard' })
    },
    requestEarlyLeave() {
      this.$router.push('/request/early-leave').catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },


    openProjectManagement(){
      this.back();
      return this.$router.push({ name : `JobCardManagement` });
    },
    stockDispatch(){
      this.back();
      return this.$router.push({ name : `PendingStock` });
    },
    disputes(){
      this.back();
      return this.$router.push({ name : `DisputesPage` });
    },
    setup(){
      this.back();
      return this.$router.push({ name : `MilestonesPage` });
    },

    kycValidation(){
      this.back();
      return this.$router.push({ name : `PendingEvents` });
    },

    calendar(){
      this.back();
      return this.$router.push({ name : `calendar` });
    },
    viewStaff(){
      this.back();
      return this.$router.push({ name : `users` });
    },
    requestFunds(){
      this.back();
      return this.$router.push({ name : `RequestFunds` });
    }
    ,requestLeave(){
      this.back();
      return this.$router.push({ name : `request-leave` });
    },
    trainingSection(){
      this.back();
      return this.$router.push({name : `training-section`});
    },
    convertExcelToJson(){
      this.back();
      return this.$router.push({name : `convertExcel`});
    },
    viewLeaveReports(){
      this.back();
      return this.$router.push({ name : `view-leave` });
    },
    viewClearanceStatus(){
      this.back();
      return this.$router.push({ name : `ViewClearance` });
    },
    viewRequestLeave(){
      this.back();
      return this.$router.push({ name : `LeaveRequests` });
    },
    managerClearance(){
      this.back();
      return this.$router.push({ name : `Clearance` });
    },
    disciplinary(){
      this.back();
      return this.$router.push({ name : `ViewDisplinary` });
    },
    viewRoles(){
      this.back();
      return this.$router.push({ name : `roles` });
    },
    manageDepartments(){
      this.back();
      return this.$router.push({ name : `department` });
    },
    deathClearance(){
      this.back();
      return this.$router.push({ name : `deathConfig` });
    },
    fines(){
      this.back();
      return this.$router.push({ name : `fine` });
    },
    viewCustomers(){
      this.back();
      return this.$router.push({ name : `customer-list` });
    },
    // sales(){
    //   this.back();
    //   return this.$router.push({ name : `view-ads` });
    // },
    viewAds() {
      this.back();
      return this.$router.push({ name: "view-ads" });
    },
    openSalesPersonDashboard() {
      this.back();
      return this.$router.push({ name: "salesPersonDashboard" });
    },
    openAllSales() {
      this.back();
      return this.$router.push({ name: "overallSales" });
    },
    viewLeads() {
      this.back();
      return this.$router.push({ name: "view-leads" });
    },
    viewLibratas() {
      this.back();
      return this.$router.push({ name: "libratas" });
    },
    settingsPage() {
      this.back();
      return this.$router.push({ name: "settings" });
    },
    logOut() {
      this.back();
      return Swal.fire({
        title: 'Are you sure?',
        text: "You are about to be logged out!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Log out!'
      }).then((result) => {
        if (result.isConfirmed) {
          // Clear all authentication data
          this.$store.dispatch("clearPermissions");
          localStorage.removeItem('setSessionID');

          Storage.setCurrentUser(null);
          this.$store.commit('setOtpVerified', false);
          this.$router.replace({name: "login"});
        }
      })
    },
    viewSmartInvoiceSignup(){
      this.back();
      return this.$router.push({ name : `smart-invoice-product-list` })
    },
    viewSmartInvoiceStats(){
      this.back();
      return this.$router.push({ name : `smartInvoiceStats` })
    },
    openOfficeManagement(){
      this.back();
      return this.$router.push({ name : `OfficeManagement` })
    },
    openSprintManagement(){
      this.back();
      return this.$router.push({ name : `SprintManagement` })
    },
    openUATListManagement(){
      this.back();
      return this.$router.push({ name : `UATList` })
    },
    openOfficeDashboard(){
      this.back();
      return this.$router.push({ name : `officeDashboard` })
    },
    UserPerformance(){
      this.back();
      return this.$router.push({ name : `performance` })
    },
    tagStatas(){
      this.back();
      return this.$router.push({ name : `TagStatistics` })
    },
    AppMarket(){
      this.back();
      return this.$router.push({ name : `appMarket` })
    },
    Projects(){
      this.back();
      return this.$router.push({ name : `NewProjectsDashboard` })
      // return this.$router.push({ name : `projects` })
    },
    primaryProducts(){
      this.back();
      return this.$router.push({ name : `PrimaryProducts` })
    },
    subscriptionInvoices(){
      this.back();
      return this.$router.push({ name : `SubscriptionInvoices` })
    },
    OfficeManagement(){
      this.back();
      return this.$router.push({ name : `OfficeManagement` })
    },
    OfficeDashboard(){
      this.back();
      return this.$router.push({ name : `officeDashboard` })
    },
    CustomerEx(){
      this.back();
      return this.$router.push({ name : `Customer-experience` })
    },
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },
  }
}
</script>

<style lang="scss" scoped>

a {
  &:hover, &.a-exact-active {
    background: #f1f1f1;
    color: #3F8DCD;

    .icon {
      color: #3F8DCD;
    }
  }
}

.warning {
  border-radius: 50%;
  display: inline-flex; /* Ensures that the container can shrink to fit its content */
  align-items: center; /* Center the content vertically */
  justify-content: center; /* Center the content horizontally */
  box-shadow: 0 0 0 9px rgba(217, 193, 98, 0); /* Starting with transparent box-shadow */
  transform: scale(1);
  animation: pulse 2s infinite;
  transform-origin: center center; /* Ensures transform scales from the center */
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 9px rgba(217, 193, 98, 1); /* Fully opaque at start */
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 19px rgba(217, 193, 98, 0); /* Fully transparent and expanded shadow */
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 9px rgba(217, 193, 98, 1); /* Return to start */
  }
}

.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  background: white;
  height: 100%;
  overflow-y: auto;

  .user-avatar {
    display: inline-flex;
    width: 100%;
    background: url('/src/assets/img/play-banner.png') fixed;
    background-size: cover;
    color: white;
    min-height: 140px;
    background-color: rgba(50, 70, 80, 0.7);
    background-blend-mode: soft-light;

    .avatar {
      background: #40434A;
      min-width: 80px;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }

    .avatar-details {
      width: 100%;
      padding: 5px 5px 5px 10px;
      display: flex;
      flex-direction: column;
      align-items: start;
      justify-content: center;

      h5, p {
        margin: 0;
      }

      p {
        font-size: 15px;
        color: #ffffff;
        font-weight: 400;

        &:nth-child(3) {
          color: #15356E;
          font-weight: 600;
        }
      }

    }
  }
}

.menu {
  text-align: center;

  span {
    font-family: "Inter", sans-serif;
    font-size: 15px;
    font-weight: bold;
  }
}

.last-upd {
  font-weight: bold;
}

.icon {
  margin-right: 10px;
  color: #606d77;
  font-size: 1.5rem;
}

.route-btn {
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 600;
  padding-left: 10px;
  text-decoration: none;
  color: #1c1c1c;
}

#footer {
  bottom: 0;
  position: fixed;
  width: 100%;
}

.not-footer {
  margin-bottom: 100px;
}

.box-container {
  display: flex;
  justify-content: center; /* Center contents horizontally */
  margin-bottom: 10px; /* Adjust as needed */
}

.red-background-blink {
  background-color: red;
  animation: blink 1s infinite;
  padding: 10px 20px; /* Adjust height and width */
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.box {
  display: inline-block;
}

.text-white {
  color: white;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.route-btn{
  cursor: pointer;
}

.button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px;
  border-radius: 5px;
  position: relative;
  transition: background-color 0.2s ease;
}
.button:hover .tooltip {
  background-color: rgba(255, 255, 255, 0.1);
  visibility: visible;
  opacity: 1;
}
.settings-btn {
  margin-right: 10px;
  display: block;
  transition: transform 0.4s ease-in;
}
.btn-cont:hover .settings-btn {
  transform: rotate(90deg);
}
.settings-btn:active {
  animation: rot 1s linear infinite;
}
@keyframes rot {
  from {
    transform: rotate(-100deg);
  }
  to {
    transform: rotate(180deg);
  }
}
.tooltip {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

</style>
